// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-main[data-v-6dea7761] {\n  height: 100%;\n  display: flex;\n  border: 1px solid #ccc;\n}\n.list-main .list-item[data-v-6dea7761] {\n  flex: 1;\n  box-sizing: border-box;\n}\n.list-main .list-item + .list-item[data-v-6dea7761] {\n  border-left: 1px solid #ccc;\n}\n.list-main .list-des[data-v-6dea7761] {\n  color: #9c9c9c;\n  padding: 10px;\n  border-bottom: 1px solid #ccc;\n}\n.list-main .el-checkbox[data-v-6dea7761] {\n  margin: 0 30px 15px 0;\n}\n", ""]);
// Exports
module.exports = exports;
